// src/components/common/ProtectedRoute.jsx
import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, userType }) => {
  const { currentUser, userType: persistentUserType, sessionRole, loading, refreshUserProfile } = useAuth();
  const location = useLocation();
  
  // Refresh profile when route changes if needed
  useEffect(() => {
    if (currentUser && (sessionRole || persistentUserType)) {
      refreshUserProfile();
    }
  }, [currentUser, sessionRole, persistentUserType, refreshUserProfile, location.pathname]);
  
  // Show loading state while checking auth status or user type
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }
  
  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }
  
  // If a specific role is required for this route
  if (userType && persistentUserType !== userType) {
    // Get the base path by removing the 's' from the end of the user type
    // Only do this if we have a valid user type
    const basePath = persistentUserType?.endsWith('s') 
      ? persistentUserType.slice(0, -1) 
      : persistentUserType;
    
    return <Navigate to={`/${basePath}`} replace />;
  }
  
  // Render children if authenticated and authorized
  return children;
};

export default ProtectedRoute;